import React, { Fragment, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TransparentGridSpacer from './TransparentGridSpacer';
import Pictogram from '../../pagesContent/PortfolioLayout/pictograms/Pictogram';
import WhiteHexLink from '../hexLinks/WhiteHexLink';
import HexInternalLink from '../HexInternalLink';
import useWindowWidth from '../../hooks/useWindowWidth';


/** transform: transalte() is there to counter -23px margin, from
 TransparentGridSpacer where this is essential to lay grid like this.
 So we counter this effect to make grid stay in the center of the screen
 */
const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 260px;
  transform: translate(5px);
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.extraSmall}){
    width: 410px;
  } 
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.small}){
    width: 650px;
    transform: translate(23px);
  } 
`;

const StyledHexInternalLink = styled(HexInternalLink)`
  position: absolute;
  height: 135px;
  width: 160px;
  bottom: -20px;
  right: -18px;
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.extraSmall}){
    height: 170px;
    width: 205px;
    bottom: -115px;
    right: 0;
  }
`;

const LinkCaption = styled.span`
  display: inline-block;
  width: 100px;
`;


const StyledHexLink = styled(WhiteHexLink)`
  cursor: pointer;
  filter: drop-shadow( 6px 5px 0 rgba(0, 0, 0, 0.12)) grayscale(1);
  height: 145px;
  width: 160px;
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.extraSmall}){
    height: 210px;
    width: 250px;
  } 
  
  &:hover, &:focus {
    filter: drop-shadow( 12px 11px 0 rgba(0, 0, 0, 0.12));
  }
  
  &:active {
    filter: drop-shadow( 2px 1px 0 rgba(0, 0, 0, 0.12));
  }
`;


const StyledTransparentGridSpacer = styled(TransparentGridSpacer)`
  height: 215px;
  width: 185px;

  @media (min-width: ${({ theme }) => theme.screenSizeWidth.extraSmall}){
    height: 250px;
    width: 250px;
  } 
`;

PortfolioHexGrid.propTypes = {
  projectsList: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    externalLink: PropTypes.string.isRequired,
    publicURL: PropTypes.string.isRequired,
  })).isRequired,
};

function PortfolioHexGrid({
  projectsList, ...otherProps
}) {
  const windwowSize = useWindowWidth();
  const { screenSizeWidthWithoutPx } = useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <ButtonsWrapper {...otherProps}>
      {projectsList.map((project, index) => (
        <Fragment key={project.name}>
          {((windwowSize < screenSizeWidthWithoutPx.small) && (index % 2 !== 0))
              && (
                <>
                  <StyledTransparentGridSpacer isGrid />
                  <StyledTransparentGridSpacer isGrid />
                </>
              )}
          <StyledHexLink
            href={project.externalLink}
            isGrid
          >
            <Pictogram
              $height={project.size === 'big' ? '115px' : '100px'}
              $width={project.size === 'big' ? '115px' : '100px'}
              $backgroundImage={project.publicURL}
            />
          </StyledHexLink>
          {windwowSize < screenSizeWidthWithoutPx.small
            ? (
              <></>
            ) : (
              <StyledTransparentGridSpacer isGrid />
            )}
        </Fragment>
      ))}
      {windwowSize < screenSizeWidthWithoutPx.small
          && (
            <StyledHexInternalLink
              to="/contact"
              type="redHex"
            >
              <LinkCaption>
                {t('writeToUs')}
              </LinkCaption>
            </StyledHexInternalLink>
          )}
      <TransparentGridSpacer isGrid />
    </ButtonsWrapper>
  );
}

export default PortfolioHexGrid;
